function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

(async () => {
  var t = await import(window.theme.modules.baseComponent);
  customElements.define(
    "main-nav",
    class extends t.default {
      constructor(...args) {
        super(...args);

        _defineProperty(this, "elements", {
          dropdowns: "*[data-dropdown]",
        });

        _defineProperty(this, "modalInit", !1);
      }

      render() {
        this.$dropdowns
          .filter((t) => t.hasAttribute("data-offset-drop"))
          .map((t) => {
            var e = t.getBoundingClientRect();
            document.documentElement.clientWidth - e.x + e.width < 600 &&
              t.classList.add("@drop-reverse");
          });
      }

      reRender() {
        this.closest("modal-popup") &&
          !this.modalInit &&
          ((this.modalInit = !0),
          this.$dropdowns.map((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
              t = t.currentTarget.dataset.dropdown;
              const e = this.querySelector(`[data-dropby="${t}"]`);
              e.classList.toggle("!active");
            });
          }));
      }
    }
  );
})();
